import styled from 'styled-components'

export const LinkedWorkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .linked {
    display: flex;
    align-items: center;
    font-weight: 500;

    &:hover {
      opacity: 0.8;
      text-decoration: none;
    }
  }
`
export const TaskedWrapper = styled.ul`
  padding-left: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`
export const TaskedItem = styled.li`
  list-style-type: none;
`
export const TaskedLink = styled.a`
  display: flex;
  align-items: center;
  &:hover {
    opacity: 0.8;
    text-decoration: none;
  }
`
export const TaskedContent = styled.div`
  display: flex;
  flex-direction: column;
  p {
    margin-bottom: 4px;
    font-weight: 500;
  }
  .task-progress {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 500;
    color: black;
  }
`
